var _excluded = ["emphasis", "type", "marginSpace", "hasPermanentMargin", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import getBorderColor from "../../../utils/getBorderColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import TextAtm from "../TextAtm";
export var defaultProps = {
  emphasis: "medium",
  type: "solid",
  marginSpace: 3
};
var gutterSpace = 2;
var basicStyles = function basicStyles(emphasis, type, onColor) {
  return css(["height:", ";border-bottom:", " ", " ", ";"], unit(1), unit(1), type, function (props) {
    return getBorderColor(props.theme, onColor, emphasis);
  });
};
var StyledDividerAtm = styled.div.withConfig({
  componentId: "sc-1bghhys-0"
})(function (_ref) {
  var $emphasis = _ref.$emphasis,
    $type = _ref.$type,
    $marginSpace = _ref.$marginSpace,
    $hasPermanentMargin = _ref.$hasPermanentMargin,
    $hasChildren = _ref.$hasChildren,
    $onColor = _ref.$onColor;
  if (!$hasChildren) {
    return css(["", ";", " ", ""], basicStyles($emphasis, $type, $onColor), typeof $marginSpace === "number" ? css(["margin:", " 0;"], space($marginSpace)) : css(["margin:", " 0 ", ";"], space($marginSpace.top), space($marginSpace.bottom)), !$hasPermanentMargin && css(["&:first-child{margin-top:0;}&:last-child{margin-bottom:0;}"]));
  }
  return css(["display:flex;align-items:center;", " &::before,&::after{", ";content:\"\";flex:1;min-width:", ";}&::before{margin-right:", ";}&::after{margin-left:", ";}"], typeof $marginSpace === "number" ? css(["margin:", " 0;"], space($marginSpace)) : css(["margin:", " 0 ", ";"], space($marginSpace.top), space($marginSpace.bottom)), basicStyles($emphasis, $type, $onColor), space(5), space(gutterSpace), space(gutterSpace));
});
function DividerAtm(_ref2) {
  var _ref2$emphasis = _ref2.emphasis,
    emphasis = _ref2$emphasis === void 0 ? defaultProps.emphasis : _ref2$emphasis,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? defaultProps.type : _ref2$type,
    _ref2$marginSpace = _ref2.marginSpace,
    marginSpace = _ref2$marginSpace === void 0 ? defaultProps.marginSpace : _ref2$marginSpace,
    hasPermanentMargin = _ref2.hasPermanentMargin,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledDividerAtm, _extends({
    $emphasis: emphasis,
    $type: type,
    $marginSpace: marginSpace,
    $hasPermanentMargin: !!hasPermanentMargin,
    $hasChildren: !!children,
    $onColor: onColor
  }, restProps), children ? /*#__PURE__*/React.createElement(TextAtm, {
    typography: "small4",
    color: "secondary",
    align: "center"
  }, children) : null);
}
export default DividerAtm;